import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { GzLandingPageAppDataProvider } from '../dataProvider/GzLandingPageAppDataProvider';
import { API_TYPE_GZ } from '../../webcomponents.constants';

export class GzLandingPageAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, GzLandingPageAppDataProvider);
  }
}
